export default "__VITE_ASSET__DwO5i5w1__"